import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["typeSelect", "fields"]
  static values = { initialType: String }

  connect() {
    this.showFields(this.initialTypeValue || "hero")
  }

  switchType(event) {
    this.showFields(event.target.value)
  }

  showFields(type) {
    this.fieldsTargets.forEach(el => {
      const isActive = (el.dataset.sectionType === type)
      el.classList.toggle("hidden", !isActive)
      // disabled된 필드는 폼 제출 시 전송되지 않으므로 hidden 파셜의 중복 name 충돌 방지
      el.querySelectorAll("input, textarea, select").forEach(input => {
        input.disabled = !isActive
      })
    })
  }
}
